import { useCallback, useRef, useState } from 'react';


export interface ListSkeletonInput {
  loading: boolean;
  hasLoaded: boolean;
  willFetch?: boolean;
}

export function showListSkeleton({ loading, hasLoaded, willFetch = true }: ListSkeletonInput): boolean {
  if (loading) return true;
  if (!willFetch) return false;
  return !hasLoaded;
}

export function useFirstLoad(resetKey?: unknown): {
  hasLoaded: boolean;
  markLoaded: () => void;
  resetLoaded: () => void;
} {
  const [hasLoaded, setHasLoaded] = useState(false);
  const keyRef = useRef(resetKey);
  if (resetKey !== keyRef.current) {
    keyRef.current = resetKey;
    if (hasLoaded) setHasLoaded(false);
  }
  const markLoaded = useCallback(() => setHasLoaded(true), []);
  const resetLoaded = useCallback(() => setHasLoaded(false), []);
  return { hasLoaded, markLoaded, resetLoaded };
}
